export const FLIXMEDIA_DISTRIBUTOR_ID = '18113';
export const FLIXMEDIA_LANGUAGE = 'de';
export const DYSON_BRAND_ID = '446b59ad-8ca5-480b-bd6e-3ae8452498a1';
export const DYSON_BRAND_SLUG = 'dyson';
export const FLIXMEDIA_MATCH_URL = (productMpnOrEanCode: string, productCodeType: 'mpn' | 'ean') =>
  `https://media.flixcar.com/delivery/webcall/match/${FLIXMEDIA_DISTRIBUTOR_ID}/${FLIXMEDIA_LANGUAGE}/${productCodeType}/${productMpnOrEanCode}`; // NOSONAR
